import type { FeatureCollection, MultiPolygon, Polygon } from 'geojson'
import { useMemo } from 'react'
import { Layer, Source } from 'react-map-gl/mapbox'
import { useMapTheme } from '../../../theme/mapPalette.ts'

export const CoverageZonesLayer = ({ geometries, label }: { geometries: (Polygon | MultiPolygon)[]; label: string }) => {
	const mapTheme = useMapTheme()
	const data = useMemo(
		(): FeatureCollection => ({
			type: 'FeatureCollection',
			features: geometries.map((geometry) => ({ type: 'Feature', geometry, properties: {} })),
		}),
		[geometries],
	)

	return (
		<Source type='geojson' data={data}>
			<Layer
				type='line'
				paint={{
					'line-color': mapTheme.reportCoverageBoundary.stroke,
					'line-width': 1,
					'line-dasharray': [2, 2],
				}}
			/>
			<Layer
				type='symbol'
				paint={{
					'text-color': mapTheme.reportCoverageBoundary.text,
				}}
				layout={{
					'symbol-placement': 'line',
					'text-font': ['Open Sans Regular'],
					'text-field': label,
					'text-size': 12,
					'text-offset': [0, -0.75],
					'text-rotation-alignment': 'auto',
					'text-allow-overlap': false,
					'text-keep-upright': true,
					'text-max-angle': 10,
				}}
			/>
		</Source>
	)
}
